import { Heart } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export default function AIPolicyPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="ai-policy-page">
      {/* Header */}
      <header className="bg-white border-b border-border sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 text-primary">
              <Heart weight="fill" className="w-7 h-7" />
              <span className="text-xl font-bold">MEDICULDIGITAL</span>
            </Link>
            <Link 
              to="/register" 
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              ← Înapoi
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold text-foreground mb-8">
            Politica privind Utilizarea Inteligenței Artificiale
          </h1>
          
          <p className="text-muted-foreground mb-6">
            <strong>Ultima actualizare:</strong> Iunie 2026
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">1. Introducere</h2>
          <p>
            MEDICULDIGITAL utilizează tehnologii avansate de Inteligență Artificială (S8NTH Strategic Engine) pentru a analiza 
            informațiile și documentele medicale furnizate de utilizatori. Această politică descrie modul 
            în care folosim IA și limitările acesteia.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">2. Scopul Inteligenței Artificiale</h2>
          <p>
            Sistemele noastre de IA sunt concepute pentru a:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Analiza simptomelor descrise de utilizatori</li>
            <li>Interpreta documente și analize medicale încărcate</li>
            <li>Oferi informații orientative despre posibile afecțiuni</li>
            <li>Sugera recomandări generale de sănătate</li>
            <li>Identifica situații care necesită atenție medicală urgentă</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">3. Limitări Importante</h2>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 my-4">
            <p className="text-amber-800 font-medium mb-2">
              ATENȚIE: Inteligența Artificială NU poate:
            </p>
            <ul className="list-disc pl-6 space-y-1 text-amber-700">
              <li>Înlocui consultația cu un medic uman</li>
              <li>Efectua o examinare clinică</li>
              <li>Stabili un diagnostic definitiv</li>
              <li>Prescrie tratamente sau medicamente</li>
              <li>Gestiona urgențe medicale</li>
            </ul>
          </div>

          <h2 className="text-xl font-semibold mt-8 mb-4">4. Procesarea Datelor</h2>
          <p>
            Informațiile furnizate sunt procesate de modele de limbaj avansate (Large Language Models) 
            care analizează textul și imaginile pentru a genera răspunsuri relevante. 
            Procesarea respectă principiile GDPR și toate datele sunt criptate.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">5. Acuratețea Răspunsurilor</h2>
          <p>
            Deși sistemele noastre de IA sunt antrenate pe date medicale validate, răspunsurile 
            generate au caracter <strong>informativ și orientativ</strong>. Acuratețea depinde de:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Calitatea și completitudinea informațiilor furnizate</li>
            <li>Claritatea descrierii simptomelor</li>
            <li>Lizibilitatea documentelor încărcate</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">6. Responsabilitate</h2>
          <p>
            Utilizatorul este responsabil pentru:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Furnizarea de informații corecte și complete</li>
            <li>Consultarea unui medic pentru diagnostic și tratament</li>
            <li>Apelarea serviciilor de urgență în caz de simptome severe</li>
            <li>Utilizarea responsabilă a recomandărilor primite</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">7. Îmbunătățire Continuă</h2>
          <p>
            Sistemele noastre de IA sunt îmbunătățite continuu pentru a oferi răspunsuri mai 
            precise și mai relevante. Feedback-ul utilizatorilor este valoros pentru acest proces.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">8. Contact</h2>
          <p>
            Pentru întrebări despre utilizarea Inteligenței Artificiale, contactați-ne la: 
            <strong> contact@medicultaudigital.ro</strong>
          </p>

          <hr className="my-8" />
          <p className="text-sm text-muted-foreground">© 2026 MEDICULDIGITAL – Platforma Medicală S8NTH. Toate drepturile rezervate.</p>
          <p className="text-xs text-muted-foreground/70 mt-1">Powered by S8NTH Strategic Engine</p>
        </article>
      </main>
    </div>
  );
}
